import { render, staticRenderFns } from "./sa-home.vue?vue&type=template&id=63f7d65e&scoped=true&"
import script from "./sa-home.vue?vue&type=script&lang=js&"
export * from "./sa-home.vue?vue&type=script&lang=js&"
import style0 from "./sa-home.vue?vue&type=style&index=0&id=63f7d65e&scoped=true&lang=css&"
import style1 from "./sa-home.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f7d65e",
  null
  
)

export default component.exports